import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Dialog, LinearProgress } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { DeleteButton } from './styles';
import {
  IProps,
  IStateProps,
  IDispatchProps,
} from './interfaces';
import DeleteGameForm from './DeleteGameForm/component';
import { pad, padDate } from '../../../../utils';
import Button from '../../../Shared/VaultButton';
import {
  DialogHeader,
  DialogHeaderTitle,
  DialogActionsOverride,
  ActionContainer,
} from '../../../Shared/styles/dialog';
import GameScheduleForm from '../../GameScheduleForm/component';
import { IAppState } from '../../../../state/reducers';
import {
  clearAll, toggleDeleteGameDialog, updateSchedule,
} from '../../../../state/exchange/updateGameScheduleDialog';
import { selectIsUserVaultSuperAdmin } from '../../../../state/user/userOrgRole';
import { StickyProgressContainer } from '../../GameScheduleForm/styles';

class UpdateGameSchedule extends PureComponent<IProps> {
  onSaveSchedule = async () => {
    const {
      gameId,
      gameDate,
      homeTeam,
      awayTeam,
      homeGameNumber,
      visitorGameNumber,
      isActive,
      selectedSport,
      selectedLeague,
      selectedGameType,
      updateSchedule,
    } = this.props;

    updateSchedule({
      GameDate: padDate(gameDate),
      HomeTeamGameNumber: pad(homeGameNumber),
      VisitorTeamGameNumber: pad(visitorGameNumber),
      IsActive: isActive,
      HomeTeamCode: homeTeam.TeamCode,
      VisitorTeamCode: awayTeam.TeamCode,
      HomeTeamId: homeTeam._id,
      VisitorTeamId: awayTeam._id,
      NCAAGameNumber: gameId,
      Sport: selectedSport,
      League: selectedLeague,
      GameType: selectedGameType,
    });
  };

  render() {
    const {
      onExit,
      onDelete,
      selectedSchedule,
      homeTeam,
      awayTeam,
      isDeleteOpen,
      isUpdating,
    } = this.props;
    return (
      <>
        <Dialog
          open={isDeleteOpen}
          fullWidth
          maxWidth="sm"
        >
          <DeleteGameForm />
        </Dialog>
        <DialogHeader
          data-auto="UpdateScheduleDialog"
        >
          <DialogHeaderTitle>
            Update Game Schedule
          </DialogHeaderTitle>
        </DialogHeader>
        {isUpdating && (
          <StickyProgressContainer>
            <LinearProgress />
          </StickyProgressContainer>
        )}
        <GameScheduleForm />
        <DialogActionsOverride disableSpacing>
          <ActionContainer>
            <DeleteButton
              variant="primaryOnWhite"
              onClick={onDelete}
              disabled={!selectedSchedule || isUpdating}
              data-auto="DeleteGameBtn"
            >
              <DeleteIcon />
              Delete
            </DeleteButton>
            <Button
              variant="plainOnPaper"
              onClick={onExit}
              data-auto="CancelBtn"
              disabled={isUpdating}
            >
              Cancel
            </Button>
            <Button
              variant="primaryOnWhite"
              onClick={() => this.onSaveSchedule()}
              disabled={!selectedSchedule || !homeTeam || !awayTeam || isUpdating}
              data-auto="UpdateSaveBtn"
            >
              Save
            </Button>
          </ActionContainer>
        </DialogActionsOverride>
      </>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  selectedSchedule: state.exchange?.gameScheduleForm?.selectedSchedule,
  gameDate: state.exchange?.gameScheduleForm?.gameDate,
  homeGameNumber: state.exchange?.gameScheduleForm?.homeGameNumber,
  visitorGameNumber: state.exchange?.gameScheduleForm?.visitorGameNumber,
  isActive: state.exchange?.gameScheduleForm?.isActive ?? false,
  isDeleteOpen: state.exchange?.updateGameScheduleDialog?.deleteDialog?.isOpen ?? false,
  selectedSport: state.exchange?.gameScheduleForm?.selectedSport,
  selectedLeague: state.exchange?.gameScheduleForm?.selectedLeague,
  selectedGameType: state.exchange?.gameScheduleForm?.selectedExchangeGameType,
  gameId: state.exchange?.gameScheduleForm?.gameId,
  homeTeam: state.exchange?.gameScheduleForm?.homeTeam,
  awayTeam: state.exchange?.gameScheduleForm?.awayTeam,
  isVaultSuperAdmin: selectIsUserVaultSuperAdmin(state),
  isUpdating: state.exchange?.updateGameScheduleDialog?.isUpdating ?? false,
});

const mapDispatchToProps: IDispatchProps = {
  updateSchedule,
  onExit: clearAll,
  onDelete: toggleDeleteGameDialog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateGameSchedule);
